import './TabNav-83c6145e.css';

var styles = {"TabNavTabList":"prc-TabNav-TabNavTabList-0QtIV","TabNavNav":"prc-TabNav-TabNavNav-rTAFO","TabNavLink":"prc-TabNav-TabNavLink-jXRq9","Selected":"prc-TabNav-Selected-94A5r"};

export { styles as default };
